module.exports = "<div class=\"page-header\">\n\t<h1>\n\t\t<i class=\"fa fa-dashboard page-header-icon\"></i>Dashboard\n\t</h1>\n</div>"